export default [
  { value: 'requested', label: 'Requested' },
  { value: 'in progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' }
];
